import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './context/AuthContext'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import AdminUsers from './pages/admin/AdminUsers'
import AdminSchools from './pages/admin/AdminSchools'
import AdminSchoolCategories from './pages/admin/AdminSchoolCategories'
import AdminNotificationCategories from './pages/admin/AdminNotificationCategories'
import NotificationHistory from './pages/admin/NotificationHistory'
import NotificationCreate from './pages/NotificationCreate'
import MudurNotifications from './pages/mudur/MudurNotifications'
import UserLogs from './pages/UserLogs'
import Unauthorized from './pages/Unauthorized'
import TestConnection from './pages/TestConnection'

const AppRoutes = () => {
  const { userProfile, loading } = useAuth()

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-lg">Yükleniyor...</div>
      </div>
    )
  }

  return (
    <Routes>
      <Route path="/login" element={!userProfile ? <Login /> : <Navigate to="/" />} />
      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route path="/test-connection" element={<TestConnection />} />
      
      <Route path="/" element={<Dashboard />} />
      
      {/* Admin Routes */}
      <Route path="/admin/users" element={<AdminUsers />} />
      <Route path="/admin/schools" element={<AdminSchools />} />
      <Route path="/admin/school-categories" element={<AdminSchoolCategories />} />
      <Route path="/admin/notification-categories" element={<AdminNotificationCategories />} />
      <Route path="/admin/notification-history" element={<NotificationHistory />} />
      
      {/* Bildirim Routes */}
      <Route path="/notifications/create" element={<NotificationCreate />} />
      
      {/* Müdür Routes */}
      <Route path="/mudur/notifications" element={<MudurNotifications />} />
      
      {/* Log Routes */}
      <Route path="/logs" element={<UserLogs />} />
    </Routes>
  )
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App

